// import React from "react";
// import { FaFacebookF, FaInstagram, FaWhatsapp, FaTwitter } from "react-icons/fa";
// // import "/App.css";

// const teamMembers = [
//   {
//     name: "Jack Semper",
//     role: "CEO",
//     img: "/Gallerypics/zaib2.JPG",
//   },
//   {
//     name: "Philip Wilson",
//     role: "Manager",
//     img: "/Gallerypics/Zaib1.JPG",
//   },
//   {
//     name: "Amanda Rich",
//     role: "Designer",
//     img: "/Gallerypics/zaib2.JPG",
//   },
// ];

// export default function OurTeam() {
//   return (
//     <section className="team-section">
//       <h3 className="team-subtitle">OUR BEST TEAM</h3>
//       <h2 className="team-title">Our Team</h2>

//       <div className="team-container">
//         {teamMembers.map((member, index) => (
//           <div className="team-card" key={index}>
//             <div className="name-strip">
//               <span>{member.name}</span>
//             </div>
//             <img src={member.img} alt={member.name} />
//             <div className="team-info">
//               <h4>{member.name}</h4>
//               <p>{member.role}</p>
//             </div>
//             <div className="team-sidebar">
//               <a href="#"><FaFacebookF /></a>
//               <a href="#"><FaInstagram /></a>
//               <a href="#"><FaWhatsapp /></a>
//               <a href="#"><FaTwitter /></a>
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

import React, { useEffect } from "react";
// import { FaFacebookF, FaInstagram, FaWhatsapp, FaTwitter } from "react-icons/fa";
import SideSocial from "../components/sidesocial"
import AOS from "aos";
import "aos/dist/aos.css";

const teamMembers = [
  { name: "Javed Akhter", role: "CEO & GM", img: "/Gallerypics/Owner1.1.png" },
  { name: "Shahzaib Javed", role: "Social Media Manager", img: "/Gallerypics/Zaib2.JPG" },
  { name: "Asad Bin Javed", role: "Account Manager", img: "/Gallerypics/Asad1.jpg" },
];

export default function OurTeam() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const animations = ["fade-up", "fade-right", "fade-left",'fade-down'];

  return (
    <section className="team-section">
      <h3 className="team-subtitle" data-aos="fade-up">OUR BEST TEAM</h3>
      <h2 className="team-title" data-aos="fade-down" data-aos-delay="100">
        Our Team
      </h2>

      <div className="team-container">
        {teamMembers.map((member, i) => (
          <div
            className="team-card"
            key={i}
            data-aos={animations[i % animations.length]}
            data-aos-delay={i * 200} // delay between cards
          >
            {/* teal strip behind image */}
            <div className="name-strip">
              <span className="strip-text">{member.name}</span>
            </div>

            {/* image wrapper */}
            <div className="img-wrap">
              <img src={member.img} alt={member.name} />
            </div>

            {/* info */}
            <div className="team-info">
              <h4>{member.name}</h4>
              <p>{member.role}</p>
            </div>

            {/* sidebar social icons */}
            <div className="team-sidebar">
              {/* <a href="https://www.facebook.com/profile.php?id=100067043465199" aria-label="facebook"><FaFacebookF /></a>
              <a href="https://www.instagram.com/jascontracts44?igsh=eDhyZ2hiNnI2ZjJz" aria-label="instagram"><FaInstagram /></a>
              <a href="https://api.whatsapp.com/send?phone=%2B923007665370&context=AfdZtdEkAYqN2F4mgDQZzfMcSDgGd2Wdk3uduq1UT6Cg2Q3Tyo8XjM_c7Qyy2V7y-bKU0ig4khHGGpAINPHARDa0dgGaCk-qxEpBCmvVGGaCf-Kgu_MFY4TavjWg_MBW6ykO6aB2EE1-0v1yWj6pWw6yVg&source=FB_Page&app=facebook&entry_point=page_cta&fbclid=IwY2xjawMaMAJleHRuA2FlbQIxMABicmlkETFWb0gwVDQ2NXhPdGdITDFWAR6CpiSiJ4ejWS4HG49Xlo88vmwopw54FERhN1nWVA-uJGZ2DM_F7-yixZi8jw_aem_v73NFdFaex2iYBVhq5HzLw" aria-label="whatsapp"><FaWhatsapp /></a>
              <a href="#" aria-label="twitter"><FaTwitter /></a> */}
              <SideSocial/>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
